const appConfig = {
    apiUrl: 'http://localhost:3000',
    apiPrefix: '/api',
    authenticatedEntryPath: '/',
    unAuthenticatedEntryPath: '/login',
    tourPath: '/app/Account/kyc-form',
    locale: 'fa',
    enableMock: false,
    fixedTabs: [{
        id: 'home',
        path: '/',
        label: '',
        icon: 'FaHome',
        iconSize: 24,
        fixed: true,
        data: undefined,
        new: false
    }]
}

export default appConfig
